<template>
	<div class="innerBox">
		<div class="row">
			<div class="align-middle mr-3">
				<h2>Paycheck</h2>
			</div>
			<toggle-button 
				v-model="selected.isBulanan"
				:width="90"
				:height="30"
				color="#7dCE94"
				:sync="true" 
				style="margin-bottom: 0;"
				:labels="{unchecked: 'Mingguan', checked: 'Bulanan'}"
			/>
		</div>
		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<!-- {{options}} -->
			<div class="row outerBox filterBox" style="padding:0">
				<div class="col row">
                    <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
                        <label>Tipe Pekerja</label>
                        <Multiselect
							:options="options.employeeType.map(x => x.id)"
							:custom-label="opt => options.employeeType.find(x => x.id == opt).name"
                            :allow-empty="false"
                            v-model="selected.employee_type_id"
                            placeholder="Pilih Tipe Pekerja"
                        />
                    </div>
                    <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
                        <label>Tahun</label>
                        <Multiselect
                            :options="options.year"
                            :allow-empty="false"
                            v-model="selected.year"
                            placeholder="Pilih Tahun"
                        />
                    </div>
                    <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
                        <label>Bulan</label>
                        <Multiselect
                            :options="options.month.map(x => x.value)"
                            :custom-label="opt => options.month.find(x => x.value == opt).name"
                            :allow-empty="false"
                            v-model="selected.month"
                            placeholder="Pilih Bulan"
                        />
                    </div>
                    <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
                        <label>Minggu</label>
                        <Multiselect
                            :options="options.week"
                            :custom-label="opt => 'Week ' + opt"
                            :allow-empty="false"
                            v-model="selected.week"
                            placeholder="Pilih Minggu"
                        />
                    </div>
                    <div class="col-md-3 offset-md-9 mt-3" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
                        <button type="button" class="btn btn-primary" style="height:43px; margin-bottom:1.5%" @click="search()">Filter</button>
                    </div>
				</div>
			</div>
		</panel>

		<div class="row mt-3 ">
			<div class="col-md-8 col-12 order-2 order-md-1 mt-3 pr-3">
                <div class="row">
                    <h4 class="col-md-7">{{ weekLabel }}</h4>
                    <div class="col-md-5 text-right">
						<button
							class="btn btn-warning"
							@click="initiatePaycheck"
							:disabled="paycheckResponse.is_paid"
							:title="paycheckResponse.is_paid ? 'Paycheck telah dijalankan' : 'Jalankan paycheck'"
						>Jalankan Paycheck</button>
                        <button class="btn btn-info ml-3" @click="exportToExcel">Export Excel</button>
                    </div>
                </div>

                <!-- <div class="row mb-3">
                    <div class="align-middle ml-3 mr-3">
                        <span>KPI : </span>
                    </div>
					<toggle-button 
                        v-model="selected.kpiIncluded"
                        :width="90"
                        :height="30"
                        color="#7dCE94"
                        :sync="true" 
                        style="margin-bottom: 0;"
                        :labels="{unchecked: 'Tanpa', checked: 'Termasuk'}"
                    />
                </div> -->

				<div class="mt-3" style="display:block;overflow-x:auto">

					<table class="table text-center">
						<thead class="thead-dark">
							<th>Nama Pekerja</th>
							<!-- <th>Role Pekerja</th> -->
							<th>Gaji</th>
							<th>Full Attendance</th>
							<th>Bonus</th>
							<th>Penalty</th>
							<th>Total</th>
							<th>Telah Dibayar</th>
							<th>Potongan</th>
						</thead>
						<tbody v-for="(data, index) in overviewData.filter(x => !x.laborer.includes('Outsource'))" :key="index">
							<tr>
								<td>{{data.laborer}}</td>
                                <!-- <td>{{data.role}}</td> -->
								<td>Rp. {{numberWithCommas(data.base_salary)}}</td>
								<td>{{data.attendance_count==6?'Y':'N'}} ({{data.attendance_count}}/6 Days)</td>
								<td>Rp. {{numberWithCommas(data.bonus)}}</td>
								<td>Rp. {{numberWithCommas(data.penalty)}}</td>
								<td>Rp. {{numberWithCommas(parseInt(data.final_salary) - parseInt(data.deductibles ? data.deductibles : 0))}}</td>
								<td
									:style="paycheckResponse.is_paid ? 'color: green' : 'color:red'"
								>{{ paycheckResponse.is_paid ? '✔' : '✖' }}</td>
								<td>
									<input class="form-control" type="number" v-model="data.deductibles" :disabled="paycheckResponse.is_paid">
								</td>
							</tr>
						</tbody>
						
					</table>
				</div>
            </div>
            
            <!-- Bonus Start -->
			<div class="col-md-4 col-12 order-1 order-md-2 mt-3 pr-3">
				<panel class="border border-secondary rounded" :noExpand="true">
					<template slot="header">
						<h4 class="panel-title">Konfigurasi Denda Paycheck (Tipe: {{ options.employeeType.filter(x=>x.id==selected.employee_type_id)[0].name }})</h4>
					</template>

					<table class="table table-borderless" style="text-align: center;" v-if="paycheckPenalty">
						<thead style="border-bottom : 1px solid black;">
							<th>Dari Jam</th>
							<th>Ke Jam</th>
							<th>Jumlah Denda</th>
							<th v-if="isEditPenalty"><i class="fas fa-cog"></i></th>
						</thead>
						<tbody>
							<tr v-for="item in paycheckPenalty">
								<td>{{ item.lower_time_limit }}</td>
								<td>{{ item.upper_time_limit }}</td>
								<td>Rp. {{ numberWithCommas(item.penalty) }}</td>
								<td v-if="isEditPenalty">
									<button class="btn btn-outline-danger" @click="deletePaycheckPenalty(item.id)">
										<i class="fas fa-times"></i>
									</button>
								</td>
							</tr>
							<tr v-if="isEditPenalty">
								<td><input class="form-control" type="text" v-model="newPenalty.lower_time_limit" placeholder="Dari" /></td>
								<td><input class="form-control" type="text" v-model="newPenalty.upper_time_limit" placeholder="Ke" /></td>
								<td><input class="form-control" type="text" v-model="newPenalty.penalty" placeholder="Jumlah" /></td>
								<td>
									<button class="btn btn-outline-success" @click="newPaycheckPenalty">
										<i class="fas fa-plus"></i>
									</button>
								</td>
							</tr>
							<tr>
								<td colspan="4">
									<div class="w-100 text-center">
										<button class="btn btn-primary" v-if="!isEditPenalty" @click="isEditPenalty = !isEditPenalty">
											Ubah
										</button>
										<button class="btn btn-danger" v-else @click="isEditPenalty = !isEditPenalty">
											Batal
										</button>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<h4 v-else>Loading.....</h4>
				</panel>
			</div>
            <!-- Bonus End -->
		</div>

		<initiate-paycheck
			v-if="modal.new"
			:date="filtered"
			:bonus="bonus"
			@closeModal="modal.new = false"
			@updateTable="getBonus"
		></initiate-paycheck>

		<laborer-payment-detail
			v-if="modal.detail"
			:laborer_id="detailLaborerId"
			@closeModal="modal.detail = false"
		></laborer-payment-detail>

	</div>
</template>

<script>
import moment from "moment"
import qs from 'qs'
import XLSX from 'xlsx'

import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'

import initiatePaycheck from './children/initiatePaycheck'
import laborerPaymentDetail from './children/laborerPaymentDetail'

export default {
	data () {
		return {
			mobile : this.isMobile(),
			modal : {
				new : false,
				detail : false,
			},
			detailLaborerId : '',
            options : {
				employeeType : [],
                week : [],
                month : this.$store.getters.getMonth,
				year : this.$store.getters.getYear,
            },
            filter : {
                start : '',
                end : '',
                week : 1,
            },
			selected : {
				employee_type_id : null,
                week : 1,
				month : new moment().format('M'),
				year : new moment().format("YYYY"),
				kpiIncluded : true,
				isBulanan : false,
            },
            filtered : {
                week : 1,
				month : new moment().format('M'),
				year : new moment().format("YYYY"),
                kpiIncluded : true
            },
			overviewData : null,
			averageData : null,
			averageWorkingTime : null,
			bonus : {
				attendance_bonus : '',
				kpi_multiplier : '',
			},
			editBonus : false,
			editObj : {
				attendance_bonus : '',
				kpi_multiplier : '',
			},
			totalSteps : '-',

			paycheckResponse : {
				is_paid : false,
			},
			paycheckPenalty : null,
			isEditPenalty : false,
			newPenalty : {
				lower_time_limit : '',
				upper_time_limit : '',
				penalty : ''
			}
		}
	},
	components : {
		initiatePaycheck,
		laborerPaymentDetail,

		Multiselect,
		ToggleButton
	},
	async mounted () {
		await this.getEmployeeType()
        this.convertToDateFilter()

		this.determineNumberOfWeeks()
		
		// this.getBonus()
		this.getOverview();
		this.getPaycheckPenalty();
    },
    watch : {
        'selected.week' () {
            this.filter.week = this.selected.week;
        },
        'selected.month' () {
            this.selected.week = 1;
            this.convertToDateFilter();
            this.determineNumberOfWeeks();
        },
        'selected.year' () {
            this.selected.week = 1;
            this.convertToDateFilter();
            this.determineNumberOfWeeks();
        },
        'selected.isBulanan' () {
            this.$router.push({name : 'FinancePaycheckMonthly'})
        },
        // 'overviewData' : {
		// 	deep : true,
		// 	handler () {
		// 		for (var i in this.overviewData) {
		// 			this.overviewData[i].deductibles = this.overviewData[i].deductibles.replace(/[\D\s\._\-]+/g, "");
		// 			this.overviewData[i].deductibles = this.overviewData[i].deductibles ? parseInt(this.overviewData[i].deductibles, 10) : 0;
		// 			this.overviewData[i].deductibles = this.overviewData[i].deductibles.toLocaleString("en-US");
		// 		}
		// 	}
        // },
    },
    computed : {
        weekLabel () {
            let startDate = moment([this.filtered.year, this.filtered.month-1])

            // Get first monday
            let firstMonday = moment(startDate).startOf('month').isoWeekday(8)
            if(firstMonday.date() == 8) firstMonday = firstMonday.isoWeekday(-6);

            for (var i = 1; i < this.filtered.week; i++) {
                firstMonday.add(7, 'days')
            }

            return `Minggu ke-${this.filtered.week} (${firstMonday.format('MMM D YYYY')} - ${firstMonday.add(6, 'days').format('MMM D YYYY')})`;
        },
    },
	methods : {
		viewDetail (laborer_id) {
			this.detailLaborerId = laborer_id;
			this.modal.detail = true;
		},
		async getEmployeeType () {
			await this.$http.get('/api/v1/employee-types/')
			.then((resp)=>{
				this.options.employeeType = resp.data.data.map(x=>{return{id:x.id, name:x.name}});
				this.selected.employee_type_id = (resp.data.data.length > 1) ? this.options.employeeType[0].id : null;
			})
			.catch((err)=>{console.log(err)})
		},
        convertToDateFilter () {
            let startDate = moment([this.selected.year, this.selected.month-1])

            // Get first and last day of month
            this.filter.start = moment(startDate).startOf('month').format('YYYY-MM-DD')
            this.filter.end = moment(startDate).endOf('month').format('YYYY-MM-DD')
        },
        determineNumberOfWeeks () {
            let startDate = moment([this.selected.year, this.selected.month-1])

            // Get first monday
            let firstMonday = moment(startDate).startOf('month').isoWeekday(8)
            if(firstMonday.date() == 8) firstMonday = firstMonday.isoWeekday(-6);

            // Get last day of month
            let endDay = moment(startDate).endOf('month')

            // Get total of weeks in the month
            let total = 0;
            for (var curr = moment(firstMonday); curr.isBefore(endDay); curr.add(7, 'days')) total++;

            // Set selected options for week
            this.options.week.length = 0;
            for(var i = 1; i <= total; i++) this.options.week.push(i)
            // console.log(JSON.stringify(this.options.week));
        },
        search () {
			this.filtered = JSON.parse(JSON.stringify(this.selected));
			this.getOverview();
			this.getPaycheckPenalty();
			// this.getBonus();
		},
		changeBonus () {
			this.editBonus = true
			this.editObj = JSON.parse(JSON.stringify(this.bonus))
		},
		getBonus() {			
			this.$http.get(`/api/v1/paycheck-settings`)
			.then((resp)=>{
				let data = resp.data.data[0]

				this.bonus.attendance_bonus = data.attendance_bonus
				this.bonus.kpi_multiplier = data.kpi_multiplier
			})
			.catch((err)=>{console.log(err)})

            this.getOverview();
		},
		saveBonus() {
			this.$http.post(`/api/v1/paycheck-settings`, {
				name : 'test',
				attendance_bonus : parseFloat(this.editObj.attendance_bonus),
				kpi_multiplier : parseFloat(this.editObj.kpi_multiplier)
			})
			.then((resp)=>{
				this.$store.dispatch('triggerAlert', [true, ['Bonus telah berhasil di edit!']])
				this.getBonus();
				this.editBonus = false;
			})
			.catch((err)=>{console.log(err)})
		},
		async fetchLaborer () {
			try {
				let response = await this.$http.get(`/api/v1/masterData/labourer?pagination=false`)
				return response.data.data
			}
			catch(err) {
				console.log(err)
			}
		},
		async getOverview() {
			if (await this.convertFilterStartEnd()) {
				this.$http.get(`/api/v1/paycheck/${this.selected.employee_type_id}/${this.filter.start}`)
				.then(async (resp)=>{
					this.paycheckResponse = resp.data.data;

					let data = resp.data.data.paychecks;
					let filteredData = [];
					let laborerList = await this.fetchLaborer()
					
					for (var i in data) {
						// console.log(data[i].labourer_id)

						
						let laborer = laborerList.find(x => x.id == data[i].labourer_id)
						console.log(laborer)
						filteredData.push({
							laborer_id : data[i].labourer_id,
							laborer : laborer ? laborer.name : 'Karyawan Tidak Ditemukan',
							// role : laborer && laborer.labour_type[0] ? laborer.labour_type[0].labourer.name : 'Karyawan Tidak Ditemukan',
							base_salary : data[i].base_salary ? data[i].base_salary : 0,
							attendance_count : data[i].attendance_count ? data[i].attendance_count : 0,
							bonus: data[i].bonus ? data[i].bonus : 0,
							penalty : data[i].penalty ? data[i].penalty : 0,
							final_salary: data[i].final_salary ? data[i].final_salary : 0,
							deductibles: data[i].deductibles ? data[i].deductibles : 0,
						})
					}

					this.overviewData = filteredData;
				})
				.catch((err)=>{
					console.log(err);
					this.overviewData = [];
					this.paycheckResponse = [];
					this.$store.dispatch('triggerAlert', [false, err.response.data.data])
				})
			}
		},
		getPaycheckPenalty () {
			this.$http.get(`/api/v1/paycheck-penalty/${this.selected.employee_type_id}`)
			.then((resp)=>{
				this.paycheckPenalty = resp.data.data;
			})
			.catch((err)=>{console.log(err)})
		},
		convertFilterStartEnd(){
            let startDate = moment([this.filtered.year, this.filtered.month-1])

            // Get first monday
            let firstMonday = moment(startDate).startOf('month').isoWeekday(8)
            if(firstMonday.date() == 8) firstMonday = firstMonday.isoWeekday(-6);

            for (var i = 1; i < this.filtered.week; i++) {
                firstMonday.add(7, 'days')
            }

			this.filter.start = firstMonday.format('YYYY-MM-DD');
			this.filter.end = firstMonday.add(6, 'days').format('YYYY-MM-DD');

			return 'success'
		},
		exportToExcel(){
			let wb = XLSX.utils.book_new()
			var ws = XLSX.utils.json_to_sheet(this.overviewData, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws, 'Data')

			let exportFileName = `Paycheck Mingguan ${this.weekLabel}.xlsx`
			XLSX.writeFile(wb, exportFileName)
		},
		initiatePaycheck () {
			let paycheckBody = JSON.parse(JSON.stringify(this.paycheckResponse))
            delete paycheckBody.is_paid;
            paycheckBody.paychecks = this.overviewData.map(x=>{return{
				labourer_id : x.laborer_id,
				bonus : x.bonus,
				attendance_count : x.attendance_count,
				penalty : x.penalty,
                base_salary : x.base_salary,
				final_salary : parseInt(x.final_salary) - parseInt(x.deductibles),
				deductibles : x.deductibles ? x.deductibles : 0,
            }})

			this.$http.post('/api/v1/paycheck', paycheckBody)
			.then((resp)=>{
				this.$store.dispatch('triggerAlert', [true, [`Paycheck telah berhasil dijalankan untuk tanggal ${this.filter.start} sampai ${this.filter.end}`]]);
				this.getOverview();
			})
			.catch((err)=>{console.log(err)})
		},
		deletePaycheckPenalty (id) {
			this.$http.delete(`/api/v1/paycheck-penalty/${id}`)
			.then((resp)=>{
				this.$store.dispatch('triggerAlert', [true, ['Paycheck penalty telah berhasil dihapus']])
				this.getPaycheckPenalty();
			})
			.catch((err)=>{console.log(err)})
		},
		newPaycheckPenalty () {
			let problems = [];

			let regexChecker = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/
			if (!/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(this.newPenalty.lower_time_limit)) problems.push("Dari harus bef-format sebagai 'hh:mm:ss'")
			if (!/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(this.newPenalty.upper_time_limit)) problems.push("Ke harus bef-format sebagai 'hh:mm:ss'")
			if (
				isNaN(this.newPenalty.penalty)
				|| this.newPenalty.penalty == ''
				|| this.newPenalty.penalty < 0
			) problems.push("Penalty harus berbentuk nomor");

			if (problems.length > 0) {
				this.$store.dispatch('triggerAlert', [false, problems]);
				return;
			}

			this.newPenalty.penalty = parseFloat(this.newPenalty.penalty)

			this.$http.post(`/api/v1/paycheck-penalty/${this.selected.employee_type_id}`, {rules:[this.newPenalty]})
			.then((resp)=>{
				this.$store.dispatch('triggerAlert', [true, ['Konfigurasi denda baru telah berhasil ditambahkan']])
				this.getPaycheckPenalty();

				this.newPenalty.lower_time_limit = '';
				this.newPenalty.upper_time_limit = '';
				this.newPenalty.penalty = '';
				this.isEditPenalty = false;
			})
			.catch((err)=>{console.log(err);this.$store.dispatch('triggerAlert', [false, err.response.data.data])})
		}
	}
}
</script>

<style scoped>
	.pre-formatted {
		white-space: pre;
	}

	th {
		vertical-align: middle;
	}
</style>